import * as React from 'react';
import { useState, useEffect } from 'react'
import SideBar from "./SideBar";
import DocumentGrid, { GridColumnName } from "components/portal/DocumentGrid";
import { RailDocument } from "shared/models/api/models";
import SubHeader from "components/menu/SubHeader";
import { useNavigate, useLocation } from "react-router-dom";
import { AddNewForm, EditForm, RescindForm } from "./admin/AddEditDocument";
import InfoModal from "components/ui/InfoModal";
import { ReactComponent as FilterIcon } from "assets/icons/filter.svg";
import './DocumentsList.css'
import { Grid2 } from "@mui/material";
import {
    defaultDocumentFilter, defaultDocumentIcon, DocumentModules, DocumentStatuses, findDocumentView,
    getClassName, IDocumentFilter, IDocumentModule, IDocumentView, IDocumentStatus, DefaultView
} from 'components/ui/DocumentRules';
import { Toggle } from "components/ui/ToggleContent";
import { getUserExistingRulebookMode } from '../../../shared/store/applicationState';

interface IPageSizeDropdownProps {
    pageSize: number,
    setPageSize: (pageSize: number) => void,
    defaultExpanded?: boolean,
    sizes: number[]
}

const PageSizeDropdown = (props: IPageSizeDropdownProps) =>
    <span className="psl-list-container">
        <div className="psl-list">
            {props.sizes.map(s =>
                <div key={s}
                    className={"psl-item " + (s === props.pageSize ? "selected" : "")}
                    onClick={() => props.setPageSize(s)}>{s} items</div>
            )}
        </div>
    </span>
    ;

const PageSizeWithPicker = (props: IPageSizeDropdownProps) => {
    return (
        <Toggle label={props.pageSize + " items"} collapseOnChangeOf={props.pageSize}>
            <PageSizeDropdown {...props} />
        </Toggle>
    );
};

interface IToggleButtonProps {
    text: string,
    selected: boolean,
    setSelected: (selected: boolean) => void
}

const ToggleButton = (props: IToggleButtonProps) =>
    <div style={{
        backgroundColor: (props.selected ? "yellow" : "white")
    }} onClick={() => props.setSelected(!props.selected)}>{props.text}</div>;

interface IFilterDocumentsDialog {
    visible: boolean,
    setResult: (filter: IDocumentFilter | null) => void
}

const FilterDocumentsDialog = (props: IFilterDocumentsDialog) => {
    const ok = () => {
        const userFilter = {} as IDocumentFilter;

        props.setResult(userFilter);
    };

    const cancel = () => {
        props.setResult(null);
    };

    const [ver, setVer] = useState(1);
    const [modules, setModules] = useState([] as number[]);
    const [statuses, setStatuses] = useState([] as string[]);

    const toggleStatus = (s: IDocumentStatus) => {
        const idx = statuses.indexOf(s.name);

        if (idx === -1) {
            statuses.push(s.name);
        } else {
            statuses.splice(idx, 1);
        }

        setStatuses(statuses);
        setVer(ver + 1);
    };

    const toggleModule = (m: IDocumentModule) => {
        const idx = modules.indexOf(m.id);

        if (idx === -1) {
            modules.push(m.id);
        } else {
            modules.splice(idx, 1);
        }

        setModules(modules);
        setVer(ver + 1);
    };

    return (
        <div className={"modal-filter " + (props.visible ? "show" : "hide")}>

            <div className="toggle-button-list-container">
                <div className="title">By module:</div>

                <Grid2 container>
                    <Grid2>
                        <ToggleButton selected={modules.length === 0} text="All" setSelected={() => setModules([])} />
                    </Grid2>

                    {DocumentModules.map(m =>
                        <ToggleButton key={m.url} selected={modules.indexOf(m.id) === 0} text={m.name} setSelected={() => toggleModule(m)} />
                    )}
                </Grid2>
            </div>

            <div className="toggle-button-list-container">
                <div className="title">By module:</div>

                <Grid2 container>
                    <Grid2
                        className={"item clickable " + (statuses.length === 0 ? " selected" : "")}
                        onClick={() => setStatuses([])}
                    >
                        All
                    </Grid2>

                    {DocumentStatuses.filter(s => s.availableInMyDocuments).map(s =>
                        <Grid2 key={s.name}
                            className={"item clickable " + (statuses.indexOf(s.name) > -1 ? " selected" : "")}
                            onClick={() => toggleStatus(s)}
                        >
                            {s.name + statuses.indexOf(s.name)}
                        </Grid2>
                    )}
                </Grid2>
            </div>

            <div>Cancel</div>
            <div>OK</div>

        </div>
    );
};

interface IDocumentListProps {
}

const DocumentList = (props: IDocumentListProps) => {
    const [showSingleSelectMessage, setShowSingleSelectMessage] = useState(false);
    const [pageSize, setPageSize] = useState(-1);

    const [activeView, setActiveView] = useState(null as IDocumentView | null);
    const [activeFilter, setActiveFilter] = useState(null as IDocumentFilter | null);
    const [activeSubFilter, setActiveSubFilter] = useState(null as IDocumentFilter | null);
    const [userFilter, setUserFilter] = useState(null as IDocumentFilter | null);

    const [selectedModuleFilter, setSelectedModuleFilter] = useState(null as IDocumentModule | null);
    const [loadingState, setLoadingState] = useState("loading");
    const [selectedItems, setSelectedItems] = useState([] as number[]);
    const [unfilteredDocuments, setUnfilteredDocuments] = useState(null as RailDocument[] | null);
    const [filteredDocuments, setFilteredDocuments] = useState(null as RailDocument[] | null);
    const [filteredCount, setFilteredCount] = useState(0);
    const [hiddenColumns, setHiddenColumns] = useState(["Select"] as GridColumnName[]);
    const [modalFilterVisible, setModalFilterVisible] = useState(false);
    const CurrentIcon = activeSubFilter?.icon ?? activeFilter?.icon ?? activeView?.icon ?? defaultDocumentIcon;
    const WatermarkIcon = activeView?.icon;
    const showWatermark = false;

    const [showAddDocument, setShowAddDocument] = useState(false);
    const [showEditDocument, setShowEditDocument] = useState(false);
    const [showRescindDocument, setShowRescindDocument] = useState(false);
    const [actionDocumentId, setActionDocumentId] = useState(0);

    const defaultPageSize = 10;

    const clearModals = () => {
        setShowAddDocument(false);
        setShowEditDocument(false);
        setShowRescindDocument(false);
        clearSelectedItems();
    }

    const addDocument = () => {
        setShowAddDocument(true);
    };

    const editDocument = (doc: RailDocument) => {
        setActionDocumentId(doc.id);
        setShowEditDocument(true);
    };

    const recindDocument = (doc: RailDocument) => {
        setActionDocumentId(doc.id);
        setShowRescindDocument(true);
    };

    const clearSelectedItems = () => {
        setActionDocumentId(0);
        setSelectedItems([]);
    };

    const navigate = useNavigate();
    const location = useLocation();

    const switchView = (view: IDocumentView | null) => {
        if (view?.url) {
            if (view.defaultFilter) {
                navigate(view.defaultFilter.url, { replace: true });
            } else {
                navigate(view.url, { replace: true } );
            }
        }

        setActiveView(view);
    };

    const getPage = async (pageSize: number, pageNumber: number) => {
        const rulebookMode = getUserExistingRulebookMode();
        if (activeView?.pagedDataSource) {
            var result = await activeView.pagedDataSource(pageSize, pageNumber, rulebookMode!);

            return result.results;
        }
    };

    const getAllResults = async () => {
        if (activeView?.dataSource) {
            const rulebookMode = getUserExistingRulebookMode();
            var result = await activeView.dataSource(rulebookMode);

            if (activeView.sortPredicate) {
                return result.sort(activeView.sortPredicate);
            }

            return result;
        }

        return getPage(-1, 1);
    };

    const switchFilter = (filter: IDocumentFilter | null) => {
        if (filter?.url) {
            navigate(filter.url, { replace: true });
        }

        clearSelectedItems();

        if (unfilteredDocuments) {
            setActiveSubFilter(null);
        } else {
            setActiveSubFilter(filter?.subFilters ? filter.subFilters[0] : null);
        }
        
        setActiveFilter(filter);
    };

    const switchSubFilter = (filter: IDocumentFilter | null) => {
        if (filter?.url) {
            navigate(filter.url, { replace: true });
        }
        clearSelectedItems();
        setActiveSubFilter(filter);
    };

    const setPathView = (viewDataForCurrentPath: any) => {
        if (viewDataForCurrentPath.filter) {
            switchFilter(viewDataForCurrentPath.filter);

            if (viewDataForCurrentPath.subFilter) {
                switchSubFilter(viewDataForCurrentPath.subFilter);
            }
        }
        else {
            if (viewDataForCurrentPath.view.defaultFilter) {
                // use the default filter
                switchFilter(viewDataForCurrentPath.view.defaultFilter);
                navigate(viewDataForCurrentPath.view.defaultFilter.url, { replace: true });
            }
            else {
                if (viewDataForCurrentPath.view.filters?.length > 0) {
                    // take the first one
                    switchFilter(viewDataForCurrentPath.view.filters[0]);
                    navigate(viewDataForCurrentPath.view.filters[0].url, { replace: true });
                }
            }
        }

        const pageSize = viewDataForCurrentPath.view.rules?.gridConfig?.defaultPageSize ?? defaultPageSize;
        setPageSize(pageSize);
        setActiveView(viewDataForCurrentPath.view);
        applyFilters();
    }

    const setDefaultView = () => {
        if (DefaultView.url) {
            navigate((DefaultView.defaultFilter ?? DefaultView).url, { replace: true });
            return;
        }

        if (DefaultView.defaultFilter) {
            setActiveFilter(DefaultView.defaultFilter);
        }

        const pageSize = DefaultView.rules?.gridConfig?.defaultPageSize ?? defaultPageSize;
        setPageSize(pageSize);
        setActiveView(DefaultView);
        applyFilters();
    }

    const applyFilters = () => {
        if (unfilteredDocuments) {
            const filteredResults = unfilteredDocuments.filter(doc =>
                defaultDocumentFilter(doc, activeView, activeFilter, activeSubFilter, selectedModuleFilter, userFilter)
            );

            setFilteredDocuments(filteredResults);
        }
        else {
            setFilteredDocuments(null);
        }
    };

    useEffect(() => {
        if (!activeView) {
            // resolve the view from the url
            var viewDataForCurrentPath = findDocumentView(location.pathname);

            // if we found a matching view, use that view
            if (viewDataForCurrentPath?.view) {
                setPathView(viewDataForCurrentPath);
            }
            else {
                setDefaultView();
            }
        }
    }, []);

    const getHiddenColumns = () => {
        const result = [] as GridColumnName[];

        if (activeView) {
            if (!activeView.rules?.canSelect) result.push("Select");
            if (!activeView.rules?.canFavourite) result.push("Favourite");
            if (!(activeFilter ?? activeView)?.rules?.hasSubTypes) result.push("SubType");
            if (!(activeFilter ?? activeView)?.rules?.hasStatus) result.push("Status");
        }

        return result;
    };

    const getDocuments = async () => {
        setLoadingState("loading");

        await getAllResults()
            .then(result => {
                if (result) {
                    setUnfilteredDocuments(result);
                }
                setLoadingState("idle");
            })
            .catch(e => {
                setLoadingState("error");
                console.log("Error fetching documents");
                console.log(e);
            });
    };

    const onViewChange = () => {
        if (activeView && (activeView.dataSource || activeView.pagedDataSource)) {
            setUnfilteredDocuments(null);
            setFilteredDocuments(null);
            getDocuments();
            setHiddenColumns(getHiddenColumns());
            clearSelectedItems();
        }

        return () => {
        }
    };

    const updateFilteredCount = () => {
        setFilteredCount(filteredDocuments?.length ?? 0)
    };

    const handleFilterResult = (filter: IDocumentFilter | null) => {
        if (filter) {
            setUserFilter(filter);
        }

        setModalFilterVisible(false);
    };

    const openDoc = (id: number) => {
        let mode = getUserExistingRulebookMode();
        if (mode == 'cbtc') {
            mode = 'mbs';
        }
        navigate(`/pdf/view/${mode}/${id}`);
    };

    const selectManyDoc = (id: number) => {
        var arr = selectedItems.map(i => i);

        if (arr.indexOf(id)) {
            arr.push(id);

            setSelectedItems(arr);
        } else {
            setSelectedItems(arr.filter(x => x !== id));
        }
    }

    const selectSingleDoc = (id: number) => {
        setSelectedItems([id]);
    }

    const setFiltersIfRequired = () => {
        let currentPath = location.pathname;
        if (activeFilter?.url != currentPath) {
            let docView = findDocumentView(currentPath);
            if (docView?.filter) {
                setActiveFilter(docView.filter);
            }
            if (docView?.subFilter) {
                setActiveSubFilter(docView.subFilter);
            }
            else {
                setActiveSubFilter(null);
            }
        }
    }

    useEffect(setFiltersIfRequired, [props]);
    useEffect(onViewChange, [activeView]);
    useEffect(applyFilters, [activeFilter, activeSubFilter, selectedModuleFilter, userFilter, unfilteredDocuments]);
    useEffect(updateFilteredCount, [filteredDocuments]);

    return (
        <div className={"document-list " + getClassName(activeView) + " " + loadingState}>

            <div className="back-drop-bottom" />

            <div className="back-drop">
                {showWatermark && <WatermarkIcon className="document-watermark" />}
            </div>

            <div className="document-modals">

                <AddNewForm isOpen={showAddDocument} onUpdate={getDocuments} onClose={clearModals} />

                <EditForm isOpen={showEditDocument} onUpdate={getDocuments} onClose={clearModals} documentId={actionDocumentId} />

                <RescindForm isOpen={showRescindDocument} onUpdate={getDocuments} onClose={clearModals} documentId={actionDocumentId} />

            </div>

            <FilterDocumentsDialog visible={modalFilterVisible} setResult={handleFilterResult} />

            <div className="narrow-container">
                <SubHeader />
                <Grid2 container className="no-gutters">
                    <Grid2 size={{ xs: 12, md: 3 }} id="sidebar-wrapper">
                        <SideBar
                            activeView={activeView}
                            setActiveView={switchView}
                            activeFilter={activeFilter}
                            setActiveFilter={switchFilter}
                            activeSubFilter={activeSubFilter}
                            setActiveSubFilter={switchSubFilter}
                            selectedModuleFilter={selectedModuleFilter}
                            setSelectedModuleFilter={setSelectedModuleFilter}
                            documentCount={unfilteredDocuments?.length ?? 0}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 9 }} id="page-content-wrapper">
                        <div className="document-list-container box-shadow">
                            <div>
                                <Grid2 container className="document-list-heading">
                                    <Grid2 size={{ xs: 10, md: 6 }} className="title">
                                        <CurrentIcon className="icon" /> {(activeSubFilter ?? activeFilter ?? activeView)?.name}
                                    </Grid2>
                                <Grid2 size={{ md: 6 }} className="summary">
                                        <table style={{ float: 'right' }}>
                                            <tbody>
                                                <tr>
                                                    {pageSize > -1 &&
                                                        <td className="page-size">
                                                            <PageSizeWithPicker
                                                                pageSize={pageSize}
                                                                setPageSize={setPageSize}
                                                                sizes={[10, 20, 50, 100]}
                                                            />
                                                        </td>
                                                    }
                                                    <td>{pageSize > -1 ? "per page of" : ""} <span>{filteredCount}</span> results</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Grid2>
                                    <Grid2 size={{ xs: 2 }} className="filter">
                                        <span className="button-container" onClick={() => setModalFilterVisible(true)}>
                                            <FilterIcon />
                                        </span>
                                    </Grid2>
                                </Grid2>
                            </div>

                            <DocumentGrid
                                key={activeSubFilter?.url ?? activeFilter?.url ?? activeView?.url ?? 1}
                                documents={filteredDocuments}
                                onDataChanged={getDocuments}
                                selectedItems={selectedItems}
                                documentSelectAction={selectSingleDoc}
                                documentButtonAction={openDoc}
                                hiddenColumns={hiddenColumns}
                                clearSelected={clearSelectedItems}
                                pageSize={pageSize}
                                onAddDocument={addDocument}
                                onEditDocument={editDocument}
                                onRescindDocument={recindDocument}
                                filter={activeSubFilter ?? activeFilter ?? activeView}
                            />

                        </div>
                    </Grid2>

                    <div className="footer-space">&nbsp;</div>
                </Grid2>

                <InfoModal text="Only one document can be selected for editing" isOpen={showSingleSelectMessage} closeAction={() => setShowSingleSelectMessage(false)} />
            </div>
        </div>
    );
};

export default DocumentList;